<template>
  <transition name="drawer-fade">
    <div v-if="open" class="drawer-overlay" @click.self="close">
      <div
        class="drawer-panel"
        role="dialog"
        aria-labelledby="generated-reports-drawer-title"
      >
        <header class="drawer-header">
          <h4 id="generated-reports-drawer-title" class="mb-0">
            Generated Reports
          </h4>
          <button
            type="button"
            class="btn btn-link text-muted p-0"
            aria-label="Close"
            @click="close"
          >
            <i class="fas fa-times fa-lg"></i>
          </button>
        </header>
        <div class="drawer-body">
          <GeneratedReportsHistory
            :report-type="reportType"
            :per-page="10"
            :containerless="true"
            :poll-interval-ms="5000"
            :focusedReport="focusedReport"
            :seen-at-open-ids="seenAtOpenIds"
          />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import GeneratedReportsHistory from "@/components/reports/GeneratedReportsHistory.vue";

export default {
  name: "GeneratedReportsDrawer",
  components: { GeneratedReportsHistory },
  props: {
    open: { type: Boolean, default: false },
    reportType: { type: String, required: true },
    focusedReport: { type: Number, default: 0 },
    seenAtOpenIds: { type: Array, default: () => [] },
  },
  emits: ["update:open"],
  methods: {
    close() {
      this.$emit("update:open", false);
    },
  },
  watch: {
    open(value) {
      document.body.style.overflow = value ? "hidden" : "";
    },
  },
  beforeUnmount() {
    document.body.style.overflow = "";
  },
};
</script>

<style scoped lang="scss">
.drawer-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 1050;
  display: flex;
  justify-content: flex-end;
}

.drawer-panel {
  background: var(--body-bg-color);
  width: 100%;
  max-width: 900px;
  height: 100%;
  display: flex;
  flex-direction: column;
  box-shadow: -4px 0 16px rgba(0, 0, 0, 0.12);
  animation: slide-in 0.25s ease;
}

.drawer-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.5rem;
  border-bottom: 1px solid #e5e7eb;
}

.drawer-body {
  flex: 1;
  overflow-y: auto;
  padding: 0.5rem 0.75rem;
}

.drawer-fade-enter-active,
.drawer-fade-leave-active {
  transition: opacity 0.2s ease;
}

.drawer-fade-enter-from,
.drawer-fade-leave-to {
  opacity: 0;
}

@keyframes slide-in {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}
</style>
